import store from '../../../store'

window.TTN_SAVE_COMMENT = new Vue({
	store,
	el: '#ttn_save_comment',
	name: "TTN_SAVE_COMMENT",
	created() {
		EventBus.$on('save_comment_ttn', this.save_comment_ttn)
	},

	methods: {
		save_comment_ttn(ttnData) {
			console.log('save_comment_ttn', ttnData)
			const is_ok = confirm_imc('Виконати ?');
			is_ok.then(res => {
				IMC_CORE.showloading();
				const ttnId = ttnData?.id ?? '';
				api.post('/nfc/ttn/' + ttnId + '/save_comment', ttnData).then(({data}) => {
					if (data.status == "operation_success") {
						window.location.reload();
					} else {
						IMC_CORE.hideloading();
						EventBus.$emit('show_toast', {err: 'Помилка збереження', type: "danger", title: 'Помилка'})
					}
				}).catch(err => {
					IMC_CORE.hideloading();
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
			});
		},
	},
})


